import { forwardRef } from 'react';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';
import { mediaMinWidth } from '@prose-ui/utils/media';

import { Image } from 'Components/Image';
import SlideShow from 'Components/SlideShow';
import { Typography } from 'Components/Typography';

import ConsultationCTA from 'Containers/ConsultationCTA';

import membershipHeroCleanser from 'assets/images/membership/prose-custom-cleanser-with-model.png';
import membershipHeroCurlCream from 'assets/images/membership/prose-custom-curl-cream-with-model.png';
import membershipHeroMoisturizer from 'assets/images/membership/prose-custom-moisturizer-with-model.png';
import membershipHeroShampoo from 'assets/images/membership/prose-custom-shampoo-with-model.png';

// #region 1st Level - Wrapper
const HeroWrapper = styled('section')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  [legacyTheme.breakpoints.up('md')]: {
    justifyContent: 'space-evenly',
    flexDirection: 'row',
  },
  width: '100%',
  padding: '28px 16px',
  backgroundColor: theme.colors.primary[400],
});
// #endregion

// #region 2nd level - SlideShow / Portraits Container
const PortraitTitleContainer = styled('div')({
  position: 'relative',
  width: 350,
  height: 450,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [legacyTheme.breakpoints.up('sm')]: {
    height: 600,
    width: 600,
  },
  [legacyTheme.breakpoints.up('lg')]: {
    width: 600,
  },
});

const TopTypography = styled(Typography)({
  position: 'absolute',
  top: 0,
  left: 0,
});

const BottomTypography = styled(Typography)({
  position: 'absolute',
  bottom: 0,
  right: 0,
});
// #endregion

// #region 2nd level - Subtitle / CTA Container
const SubtitleContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
});

const SubtitleTypography = styled(Typography)({
  width: 350,
  [legacyTheme.breakpoints.up('sm')]: {
    width: 500,
  },
});

const StyledConsultationCTA = styled(ConsultationCTA)({ width: 350, marginTop: 50 });
// #endregion

const SubtitleDescription = styled('div')({
  width: '250px',
});

const SlideShowPortrait = styled(Image)`
  object-fit: contain;
  max-width: 300px;
  max-height: 400px;

  ${mediaMinWidth('sm')} {
    max-width: 500px;
    max-height: 538px;
  }
`;

const ProspectHero = forwardRef((_props, ref) => {
  return (
    <HeroWrapper ref={ref}>
      <PortraitTitleContainer>
        <TopTypography color="lavender" upperCase variant="hero-mono">
          Commit
          <br />
          to
        </TopTypography>
        <SlideShow>
          <SlideShowPortrait
            alt="Prose model posing with custom curl cream"
            src={membershipHeroCurlCream}
          />
          <SlideShowPortrait
            alt="Prose model posing with custom cleanser"
            src={membershipHeroCleanser}
          />
          <SlideShowPortrait
            alt="Prose model posing with custom shampoo"
            src={membershipHeroShampoo}
          />
          <SlideShowPortrait
            alt="Prose model posing with custom moisturizer"
            src={membershipHeroMoisturizer}
          />
        </SlideShow>
        <BottomTypography align="right" bold color="lime" upperCase variant="hero-mono">
          Custom
          <br />
          Care
        </BottomTypography>
      </PortraitTitleContainer>
      <SubtitleContainer>
        <SubtitleTypography align="center" color="white" paragraph variant="h1r">
          A subscription service delivering custom care on demand
        </SubtitleTypography>
        <SubtitleDescription>
          <Typography align="center" color="white" paragraph variant="mono1">
            Save 15％
            <br />
            when you subscribe to haircare and skincare.
          </Typography>
          <Typography align="center" color="white" variant="mono1">
            Free shipping, cancel&nbsp;anytime
          </Typography>
        </SubtitleDescription>
        <StyledConsultationCTA
          dataFrom="membership-lp-prospects"
          label="Begin yours here"
          variant="lime"
        />
      </SubtitleContainer>
    </HeroWrapper>
  );
});

export default ProspectHero;
